import React from 'react';
import { WrapperFlex, Button } from '@unimed-fesp/components';

import { ContentText } from '../PartsModalParametrizacao/styles';

const BodyEnviarListaRpa = ({ qtdListas = 1, hasFake = false }) => {
  if (qtdListas <= 0)
    throw new Error('A propriedade "qtdListas" deve ser maior que 0');

  const SINGULAR = qtdListas === 1;

  if (hasFake)
    return (
      <ContentText>
        {SINGULAR
          ? 'Lista _TESTE criada por um Admin parametrizado! '
          : 'Existem listas _TESTE criadas por um Admin parametrizado! '}
        <strong>
          {SINGULAR
            ? 'O Robô RPA não conseguirá utilizá-la'
            : 'O Robô RPA não conseguirá utilizá-las'}
        </strong>
        .
        <br />
        {SINGULAR
          ? 'Deseja enviar a lista para o RPA?'
          : 'Deseja enviar as listas para o RPA?'}
      </ContentText>
    );

  return (
    <ContentText>
      Apenas listas com status <strong>Pendente de Processamento</strong> serão
      enviadas.
      <br />
      Listas de inativos não serão enviadas.
      <br />
      {SINGULAR
        ? 'Deseja enviar a lista para o RPA?'
        : 'Deseja enviar as listas para o RPA?'}
    </ContentText>
  );
};

const FooterEnviarListaRpa = ({ closeModal, onClickOk }) => {
  return (
    <WrapperFlex justifySpaceAround minWidth={250}>
      <Button tipo="secondary" onClick={closeModal} width={100} justifyCenter>
        não
      </Button>
      <Button onClick={onClickOk} width={100} justifyCenter>
        sim
      </Button>
    </WrapperFlex>
  );
};

export default { BodyEnviarListaRpa, FooterEnviarListaRpa };
